import * as TK from 'components/auth/ForgotPasswordForm/translations/constants';
import { Translations } from 'translations/types';

export const forgotPasswordFormEnUsLocale: Translations = {
  [TK.FORGOT_PASSWORD_FORM_EMAIL_PLACEHOLDER]: 'Email',
  [TK.FORGOT_PASSWORD_EMAIL_INVALID_ERROR_MESSAGE]: 'Please enter a valid email address.',
  [TK.FORGOT_PASSWORD_FORM_SUBMIT_BUTTON_LABEL]: 'Submit',
};
